
import Component from "vue-class-component"
import AbstractPage from "@/report/pages/AbstractPage.vue"
import BiSectionPage from "@/report/pages/BiSectionPage.vue"

@Component({name: "AsfaBalancePage", components: {BiSectionPage}})
export default class AsfaBalancePage extends AbstractPage {}
